import { Injectable } from '@angular/core';
import { AuthStorageService } from '@spartacus/core';
import { take } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthRehydratorService {
    private readonly AUTH_KEY = 'spartacus⚿⚿auth';
    constructor(private authStorage: AuthStorageService) {}
    run(): void {
        const authKey = JSON.parse(localStorage.getItem(this.AUTH_KEY));
        if (authKey?.userId == 'anonymous') return;
        const token = authKey?.token;
        try {
            if (token?.access_token && (Date.now() < Number(token?.expires_at))) {
                this.authStorage.getToken().pipe(take(1)).subscribe((currentToken) => {
                    if (!currentToken?.access_token)
                        this.authStorage.setToken(token);
              });
            }
          } catch (e) {
          }
    }
}
